"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupUserProvider = void 0;
var _LogoutExecutor = _interopRequireDefault(require("../components/LogoutExecutor"));
var _LogoutProvider = _interopRequireDefault(require("../components/LogoutProvider"));
const setupUserProvider = () => {
  // Allow for debugging in Online context
  if (typeof window !== 'undefined' && window.ori && !window.ori?.userSessionProvider) {
    const logoutExecutor = new _LogoutExecutor.default();
    const logoutCallback = () => {
      logoutExecutor.doLogout();
    };
    const userSessionProviderApi = {
      logoutProvider: new _LogoutProvider.default(logoutCallback, window),
      logoutExecutor,
      logoutCallback
    };
    // @ts-expect-error -- We need to assign to ori property
    window.ori.userSessionProvider = userSessionProviderApi;
  }
};
exports.setupUserProvider = setupUserProvider;
